import { createAction, props } from '@ngrx/store';
import type { HomeBatteryWizardFormData } from '@feh/homebattery-models';

const PREFIX = '[FEH Homebattery Wizard]';

export const homeBatteryWizardFormSubmitAction = createAction(
  `${PREFIX} Submit form`,
  props<HomeBatteryWizardFormData>()
);

export const homeBatteryWizardConsumptionQuestionnaireOpenModalAction =
  createAction(`${PREFIX} Open questionnaire modal`);

export const homeBatteryWizardConsumptionQuestionnaireCloseModalAction =
  createAction(`${PREFIX} Close questionnaire modal`);
